<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-21 10:31:19
-->
<template>
    <div>
        <!-- <a-collapse class="collapse" :default-active-key="['1']" accordion :onChange="onChange">
            <a-collapse-item :header="$t('base.search')" key="1">
                <Form :form="returnQueryForm" @handleSelectChange="handleSelectChange">
                    <template v-slot:formBtn>
                        <div style="margin-left:-110px">
                            <a-button class="form_btn" type="primary" @click="handle('search')">{{ $t('base.search') }}</a-button>
                            <a-button class="form_btn" type="outline" @click="handle('reset')">{{ $t('base.reset') }}</a-button>
                        </div>
                    </template>
                </Form>
            </a-collapse-item>
        </a-collapse> -->

        <Table
            ref="orderTableRef"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >

            <!-- 自定义字段 -->
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'status'">
                    <a-tag :color="statusColor[props.record.status_val]">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'courier_status'">
                    <a-tag v-if="props.record.courier_status !== '-'" :color="courierStatusColor[props.record.courier_status_val]">{{ props.record.courier_status }}</a-tag>
                    <span v-else>-</span>
                </div>
            </template>

             <!-- 表格操作 -->
             <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" :disabled="!props.record.file" @click="handle('seeFile',props.record)">{{ $t('returnExchange.seeFile') }}</a-button>
            </template>
        </Table>

        <!-- 查看附件 -->
        <ImagePreview :srcList="srcList" :visibleImg="visible" @close="close"/>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import ImagePreview from '@/components/ImagePreview.vue';
    import { ReturnQueryForm } from './queryConfig/OrderListQuery.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const props = defineProps({
        visible:{
            type:Boolean,
            default:false,
        },
        rowData:{
            type:Object,
            default:()=>{}
        }
    })

    const { t } = useI18n()
    const returnQueryForm = reactive(ReturnQueryForm)
    const table = ref({
        datas:[],
        columns:[
            {
                // title: 'mes退货单号',
                title:t('returnExchange.backNumber'),
                dataIndex: 'back_number',
                key:'back_number',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
                fixed:'left'
            },
            {
                // title: '产品名称',
                title:t('returnExchange.productName'),
                dataIndex: 'product_name',
                key:'product_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: 'sku',
                title:t('returnExchange.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: 'ERP编号',
                title:t('returnExchange.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'130',
                align:'center',
            },
            {
                // title: '订单行号',
                title:t('returnExchange.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'140',
                align:'center',
            },
            {
                // title: 'erp物料号',
                title:t('returnExchange.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '状态',
                title:t('returnExchange.status'),
                dataIndex: 'status',
                key:'status',
                width:'170',
                align:'center',
                slotName:'slot'
            },
            {
                // title: '来源',
                title:t('returnExchange.source'),
                dataIndex: 'source',
                key:'source',
                width:'120',
                align:'center',
            },
            {
                // title: '数量',
                title:t('returnExchange.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                align:'center',
            },
            {
                // title: '退换货原因类型',
                title:t('returnExchange.backReasonType'),
                dataIndex: 'back_reason_type',
                key:'back_reason_type',
                width:'180',
                align:'center',
            },  
            {
                // title: '退换货原因',
                title:t('returnExchange.backReason'),
                dataIndex: 'back_reason',
                key:'back_reason',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '退货时间',
                title:t('returnExchange.backTimestamp'),
                dataIndex: 'back_timestamp',
                key:'back_timestamp',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '退货实际收到时间',
                title:t('returnExchange.backRealTimestamp'),
                dataIndex: 'back_real_timestamp',
                key:'back_real_timestamp',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'IBS验证方案类型',
                title:t('returnExchange.ibsVerificationType'),
                dataIndex: 'ibs_verification_type',
                key:'ibs_verification_type',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'IBS验证方案描述',
                title:t('returnExchange.ibsVerificationPlan'),
                dataIndex: 'ibs_verification_plan',
                key:'ibs_verification_plan',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '折扣',
                title:t('returnExchange.discount'),
                dataIndex: 'discount',
                key:'discount',
                width:'100',
                align:'center',
            },
            {
                // title: '客户名称',
                title:t('returnExchange.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'erp客户编码',
                title:t('returnExchange.customerErpCode'),
                dataIndex: 'customer_erp_code',
                key:'customer_erp_code',
                width:'200',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '退货物流状态',
                title:t('returnExchange.backCourierStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '物流单号',
                title:t('returnExchange.backCourierNo'),
                dataIndex: 'courier_no',
                key:'courier_no',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流公司',
                title:t('returnExchange.backCourierType'),
                dataIndex: 'courier_type',
                key:'courier_type',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '150',
                align: 'center',
                fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false
            
        },
    })

    const srcList = ref([])
    const visible = ref(false)
    const reasonTypeObj = ref({})
    const sourceObj = ref({})
    const IBSTypeObj = ref({})
    const statusObj = {
        0:t('returnExchange.initial'),
        1:t('returnExchange.returning'),
        // 2:t('returnExchange.exchangeProgress'),
        2:t('returnExchange.returnSuccessful'),
        3:t('order.cancelReturn'),
        // 4:t('returnExchange.exchangeSuccessful'),
    }
    const statusColor = ref({
        // 0:'blue',
        // 1:'red',
        // 2:'orange',
        // 3:'lime',
        // 4:'green',
        0:'blue',
        1:'red',
        2:'green',
        3:'orange',
    })

    const courierStatus = ref({ // 退货物流状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
    })
    const courierStatusColor = ref({
        0:'red',
        1:'plan',
        2:'orange',
        3:'lime',
        4:'green',
        5:'gray',
    })

    const formatField = (key,data)=>{
        if(key == 'status'){
            return statusObj[data]
        }
        else if(key == 'source'){
            return sourceObj.value[data]
        }
        else if(key == 'back_reason_type'){
            return reasonTypeObj.value[data]
        }
        else if(key == 'ibs_verification_type'){
            return IBSTypeObj.value[data]
        }
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                getReturnList()
                break;
            case 'reset':
                returnQueryForm.formField.forEach(i=>{
                    returnQueryForm.formData[i.key] = ''
                })
                getReturnList()
                break;
            case 'seeFile':
                srcList.value = row.file.split(',')
                visible.value = true
                break;
        }
    }

    const close = (val)=>{
        visible.value = val
    }

    const handleSelectChange = ( val, opt, key )=>{
        returnQueryForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getReturnList()
    }

    // 获取退货列表
    const getReturnList = async ()=>{
        let param = {
            type:1,
            order_id: props.rowData.id,
        }

        table.value.configs.loading = true
        let res = await OrderApi.getInstance().getReturnExchangeList(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                i.status_val = i.status
                i.product_name = i.product_map.english_name
                i.status = formatField('status',i.status)
                i.source = formatField('source',i.source)
                i.back_reason_type = formatField('back_reason_type',i.back_reason_type)
                i.ibs_verification_type = i.ibs_verification_type == undefined ? '-' : formatField('ibs_verification_type', i.ibs_verification_type)
                i.ibs_verification_plan = i.ibs_verification_plan == undefined? '-' : i.ibs_verification_plan,
                i.discount = '€ ' + i.discount
                i.customer_erp_code = i.customer_erp_code == undefined? '-' : i.customer_erp_code
                i.back_timestamp = timestampToDate(i.back_timestamp * 1000)
                i.back_real_timestamp = i.back_real_timestamp == undefined? '-' : timestampToDate(i.back_real_timestamp * 1000)
                i.courier_no = i.back_courier_map == undefined? '-' : i.back_courier_map.courier_no
                i.courier_type = i.back_courier_map == undefined? '-' : i.back_courier_map.courier_type
                i.courier_status_val = i.back_courier_map == undefined || i.back_courier_map.courier_status == undefined? '-' : i.back_courier_map.courier_status
                i.courier_status = i.back_courier_map == undefined || i.back_courier_map.courier_status == undefined? '-' : courierStatus.value[i.back_courier_map.courier_status]
                i.model = i.product_map == undefined ? '-' : i.product_map.model == undefined? '-' : i.product_map.model
                i.model_year = i.product_map == undefined ? '-' : i.product_map.model_year == undefined? '-' : i.product_map.model_year
                i.brand_name = i.product_map == undefined ? '-' : i.product_map.brand_name == undefined? '-' :  i.product_map.brand_name
                i.part_name = i.product_map == undefined ? '-' : i.product_map.part_name == undefined? '-' :  i.product_map.part_name
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "back_reason"})
        if(res.code == 0){
            let item = returnQueryForm.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })  

            item.options.forEach(i=>{
                reasonTypeObj.value[Number(i.value)] = i.label
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            res.data.forEach(i=>{
                IBSTypeObj.value[Number(i.dict_sub_value)] = i.dict_sub_name
            })
            console.log(IBSTypeObj.value,'IBSTypeObj')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型
    const getOrderSource = async ()=>{
        // let res = await OrderApi.getInstance().getCourierType({dict_code: "erp",dict_sub_code: "customer"})
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            res.data.forEach(i=>{
                sourceObj.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
            })
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.visible,(val)=>{
        if(val) getReturnList()
    })

    onMounted(async ()=>{
        await getOrderSource()
        await getReasonType()
        await getIBSType()
        getReturnList()
    })
</script>

<style lang="less" scoped>
.collapse{
    margin-bottom: 10px;
    /deep/ .arco-collapse-item-content{
        background-color: #fff;
    }

    .form_btn{
        margin: 0 10px;
    }
}
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}
</style>